<template>
  <div>
    <b-modal
        id="modal-center"
        v-model="show"
        centered
        :noCloseOnEsc="true"
        :noCloseOnBackdrop="true"
        title="Center modal"
        title-class="font-18"
        hide-footer
        hide-header>
      <Loader :loading="true">
        <p class="text-white mt-3">
          Cras mattis consectetur purus sit amet fermentum.
          Cras justo odio, dapibus ac facilisis in,
          egestas eget quam. Morbi leo risus, porta ac
          consectetur ac, vestibulum at eros.
        </p>
      </Loader>
      <div class="text-center mb-3">
        <h3>Aguarde</h3>
        <p>Se você sair, esta ação será cancelada.
          <br>Abra uma nova guia para acessar outros recursos enquanto essa ação estiver em andamento.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loader from "@/components/widgets/loader";

export default {
  components: {
    Loader,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {};
  },
};
</script>
